import { createStoreUnit } from 'src/redux/helpers';
import { MONITORING_STORE } from '../constants';
import monitoringUrlList from './MonitoringUrlSlice';

const monitoringListSlice = createStoreUnit({
  name: MONITORING_STORE,
  slices: {
    monitoringUrlList,
  },
});

export default monitoringListSlice;
